function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1475 -890)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 39.052)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1474 850.948)",
  fill: "#fff",
  stroke: "#4c9462",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  d: "M4.9-44.829a.344.344,0,0,1-.255-.1.344.344,0,0,1-.1-.255v-.6a.372.372,0,0,1,.1-.263.33.33,0,0,1,.255-.1h.6a.356.356,0,0,1,.263.1.356.356,0,0,1,.1.263v.6a.33.33,0,0,1-.1.255.372.372,0,0,1-.263.1Zm.175,9.981a.344.344,0,0,1-.255-.1.344.344,0,0,1-.1-.255v-7.577a.344.344,0,0,1,.1-.255.344.344,0,0,1,.255-.1h.271a.344.344,0,0,1,.255.1.344.344,0,0,1,.1.255V-35.2a.344.344,0,0,1-.1.255.344.344,0,0,1-.255.1Z",
  transform: "translate(1476.773 899.936)",
  fill: "#4c9462"
})));

var SvgInformationIcon = function SvgInformationIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInformationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/information-icon.a1212e60.svg";
export { ForwardRef as ReactComponent };